/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_EquipmentInputs */

const en_us2_search_field_equipment = /** @type {(inputs: Search_Field_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipment`)
};

const pt_br2_search_field_equipment = /** @type {(inputs: Search_Field_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipamentos`)
};

const es_419_search_field_equipment = /** @type {(inputs: Search_Field_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo`)
};

const pt_pt2_search_field_equipment = /** @type {(inputs: Search_Field_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipamento`)
};

const fr_fr2_search_field_equipment = /** @type {(inputs: Search_Field_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipement`)
};

const de_de2_search_field_equipment = /** @type {(inputs: Search_Field_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstattung`)
};

const it_it2_search_field_equipment = /** @type {(inputs: Search_Field_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attrezzatura`)
};

/**
* | output |
* | --- |
* | "Equipment" |
*
* @param {Search_Field_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_equipment = /** @type {((inputs?: Search_Field_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_equipment(inputs)
	if (locale === "es-419") return es_419_search_field_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_equipment(inputs)
	if (locale === "de-DE") return de_de2_search_field_equipment(inputs)
	if (locale === "it-IT") return it_it2_search_field_equipment(inputs)
	return en_us2_search_field_equipment(inputs)
});
export { search_field_equipment as "search.field_equipment" }